import React, { Component } from 'react';

class About extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var profilepic= "images/"+this.props.data.image;
      var bio = this.props.data.bio;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var resumeDownload = this.props.data.resumedownload;
    }

    return (
      <section id="about">
         <h1 class="aboutHeader">Meet the Team</h1>
      <div className="row">
         <div className="three columns">
            <img className="profile-pic"  src={profilepic} alt="Sapling Sam Profile Pic" />
         </div>
         <div className="nine columns main-col">
            
<h3>Sapling Sam</h3>
            <p>{bio}</p>
            <div className="row">
               
               
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;
